import { useQuery } from '@tanstack/react-query';
import { flatten } from 'lodash-es';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { DATA_REFRESH_RATE_IN_MILLIS_SHORT } from 'src/utils/constants/constants';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { SaleClient } from 'src/WebApiController';

export const useGetUnableToProcessSales = (disabled?: boolean) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();

  return useQuery({
    queryKey: [
      'SaleClient.getUnableToProcessSales',
      disabled,
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: async () => {
      if (!disabled || activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }

      return tryInvokeApi(
        async () => {
          const client = new SaleClient(activeAccountWebClientConfig);
          const data = await client.getUnableToProcessSales();

          return flatten(Object.values(data));
        },
        (error: ErrorTypes) => {
          trackError('SaleClient.getUnableToProcessSales', error);
        }
      );
    },
    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
    networkMode: 'offlineFirst',
    refetchInterval: DATA_REFRESH_RATE_IN_MILLIS_SHORT,
    refetchIntervalInBackground: true,
  });
};
